<template>
	<div>
		<el-row>

			<el-col :offset="3" :span="17">
				
				<img src="https://qq-gjx.oss-cn-shanghai.aliyuncs.com/pc/logo.png" height="100" style="margin-top: -15px;" />
			
			</el-col>
			
	
				<el-col :span="4" style="text-align: right;">
								<el-button style="margin-top: 2%; " @click="openPay()"> 捐赠</el-button>	
				<el-button style="margin-top: 2%; " @click="openLogin()"> 登录</el-button>	
				</el-col>
		</el-row>



<!-- 		<el-carousel trigger="click" height="1000px" style="text-align: center;" indicator-position="none">
			<el-carousel-item v-for="item in imgList" :key="item.url">
				<img :src="item.url" width="100%" height="100%">
			</el-carousel-item>
		</el-carousel>
 -->
<div src="https://www.lqcpws.cn/se/src/fallen-leaves/" style="height: 2500px;width: 100%;"   ></div>
		<div class="myLeft">
			<el-card class="box-card" shadow="never">
		<!-- 		<div slot="header" class="clearfix">
					<div style="padding-top: 0.5%;float: left;">
					<img src="https://qq-gjx.oss-cn-shanghai.aliyuncs.com/pc/%E5%85%AC%E5%91%8A.png" width="20px" height="20px"></img>
					</div>&nbsp;&nbsp;公告
				</div>
				<div v-for="o in noticeList" :key="o.id" class="notice">
					<div style="padding-top: 0.5%;float: left;">
					<img src="https://qq-gjx.oss-cn-shanghai.aliyuncs.com/pc/%E6%96%B0%E6%B6%88%E6%81%AF%E7%BA%A2%E7%82%B9.png" width="20px" height="20px"
					></img>
					&nbsp;
					</div>
					{{o.content}}
				</div> -->
				  <div class="title-wrapper">
				    <h1 class="main-title">本站热门工具(窗口化)-站长自制</h1>
				    <el-divider class="divider" content-position="left"></el-divider>
				  </div>
		  <div class="home-container">

		    <div class="app-list">
		      <div class="app-row" v-for="(row, index) in appRows" :key="index">
		        <div v-for="(app, subIndex) in row" :key="subIndex" class="app-card" >
		          <div class="app-image-wrapper">
		            <img :src="app.icon" alt="App图片" class="app-image" width="200" height="200" @click="openPath(app.url,app.id,app.name)">
		          </div>
		          <div class="app-details">
		            <h2 class="app-subtitle">{{ app.name }}</h2>
		            <p class="app-intro" :title="app.remark">{{ app.remark.length>13?app.remark.substr(0,11)+'..':app.remark }}</p>
		            <button class="app-download-btn" @click="openPath(app.url,app.id,app.name)">进入工具</button>
		          </div>
		        </div>
		      </div>
		    </div>
		  </div>
		  
		  <div class="title-wrapper">
		    <h1 class="main-title">友情链接导航</h1>
		    <el-divider class="divider" content-position="left"></el-divider>
		  </div>
		  
		  <el-row>
		  <el-col  :offset="1" :span="6">
	<el-card class="box-card" shadow="hover">
		<!-- 	<div slot="header" class="clearfix">
				<div style="padding-top: 0.5%;float: left;">
				<img src="https://qq-gjx-pc.oss-cn-shanghai.aliyuncs.com/icon/%E6%9C%BA%E5%99%A8%E4%BA%BA_o.png" width="20px" height="20px"></img>
				</div>&nbsp;&nbsp;
			</div> -->
		<div v-for="o,index in gptList" :key="o.id" class="notice" style=" cursor: pointer;  height: 30px;" @click="openPath(o.url,o.id)">
						
							&nbsp;&nbsp;{{o.name}}
		</div>
		</el-card>
		  		
		  </el-col>
		  <el-col :offset="2" :span="6">
		  	<el-card class="box-card" shadow="hover">
		  	<!-- 	<div slot="header" class="clearfix">
		  			<div style="float: left;">
		  			<img src="https://qq-gjx-pc.oss-cn-shanghai.aliyuncs.com/icon/%E8%A7%86%E9%A2%91.png" width="20px" height="20px"></img>
		  			</div>&nbsp;&nbsp;
		  		</div> -->
		  		
		  		<div v-for="o,index in videoList" :key="o.id" class="notice" style=" cursor: pointer; height: 30px;" @click="openPath(o.url,o.id)">
		  	
		  						&nbsp;&nbsp;{{o.name}}
		  		</div>
		  	</el-card>
		  		
		  </el-col>
		  <el-col :offset="2" :span="6">
		  	<el-card class="box-card" shadow="hover">
		  		<!-- <div slot="header" class="clearfix">
		  			<div style="float: left;">
		  			<img src="https://qq-gjx-pc.oss-cn-shanghai.aliyuncs.com/icon/%E6%8A%80%E6%9C%AF%E6%9C%8D%E5%8A%A1.png" width="20px" height="20px"></img>
		  			</div>&nbsp;&nbsp;
		  		</div> -->
		  <div v-for="o,index in itList" :key="o.id" class="notice" style=" cursor: pointer;  height: 30px;" @click="openPath(o.url,o.id)">
		  				 
		  					&nbsp;&nbsp;{{o.name}}
		  </div>
		  	</el-card>
		  		
		  </el-col>
		  
		  </el-row>
		  <br/><br/>
		  <el-row>
		  		<el-col :offset="1" :span="6">
	<el-card class="box-card" shadow="hover">
	<!-- 	<div slot="header" class="clearfix">
			<div style="float: left;">
			<img src="https://qq-gjx-pc.oss-cn-shanghai.aliyuncs.com/icon/%E4%BA%91%E6%9C%8D%E5%8A%A1%E5%99%A8.png" width="20px" height="20px"></img>
			</div>&nbsp;&nbsp;
		</div> -->
	<div v-for="o,index in serverList" :key="o.id" class="notice" style=" cursor: pointer;  height: 30px;" @click="openPath(o.url,o.id)">
					
					&nbsp;&nbsp;{{o.name}}
	</div>
	</el-card>
		  				
		  		</el-col>
<!-- 		  		<el-col :offset="2" :span="6">
		  <el-card class="box-card" shadow="hover">
		  				<div slot="header" class="clearfix">
		  					<div style="padding-top: 0.5%;float: left;">
		  					<img src="https://qq-gjx-pc.oss-cn-shanghai.aliyuncs.com/icon/%E7%94%9F%E6%B4%BB.png" width="20px" height="20px"></img>
		  					</div>&nbsp;&nbsp;在线生活工具
		  				</div>
		  			<div v-for="o,index in liveList" :key="o.id" class="notice" style=" cursor: pointer;  height: 30px;" @click="openPath(o.url,o.id)">
		  							
		  								{{index+1}}:&nbsp;&nbsp;{{o.name}}
		  			</div>
		  			</el-card>
		  				
		  		</el-col> -->
		  		<el-col :offset="2" :span="6">
		  			<el-card class="box-card" shadow="hover">
		  				<!-- <div slot="header" class="clearfix">
		  					<div style="float: left;">
		  					<img src="https://qq-gjx-pc.oss-cn-shanghai.aliyuncs.com/icon/%E5%8F%8B%E6%83%85%E9%93%BE%E6%8E%A5.png" width="20px" height="20px"></img>
		  					</div>&nbsp;&nbsp;
		  				</div> -->
		  		<div v-for="o,index in linkList" :key="o.id" class="notice" style=" cursor: pointer;  height: 30px;" @click="openPath(o.url,o.id)">
		  						
		  							&nbsp;&nbsp;{{o.name}}
		  		</div>
		  			</el-card>
		  				
		  		</el-col>
		  		
		  		</el-row>
		  		
			</el-card>
			
		</div>
	<!-- 	<div class="myRight">
					<br/>
			<el-row>
			<el-col  :offset="1" :span="6">
				<el-card class="box-card" shadow="hover">
					<div slot="header" class="clearfix">
						<div style="float: left;">
						<img src="https://qq-gjx-pc.oss-cn-shanghai.aliyuncs.com/icon/%E6%B8%B8%E6%88%8F%EF%BC%8C%E6%B8%B8%E6%88%8F%E6%9C%BA.png" width="20px" height="20px"></img>
						</div>&nbsp;&nbsp;在线fc游戏(可本地存档)
					</div>
					<div v-for="o,index in gameList" :key="o.id" class="notice" style=" cursor: pointer; height: 30px;" @click="openGame(o.id)">
						{{index+1}}:&nbsp;&nbsp;{{o.name}}
					</div>
				</el-card>
		
			</el-col>
			<el-col :offset="2" :span="6">
				<el-card class="box-card" shadow="hover">
					<div slot="header" class="clearfix">
						<div style="float: left;">
						<img src="https://qq-gjx-pc.oss-cn-shanghai.aliyuncs.com/icon/%E8%A7%86%E9%A2%91.png" width="20px" height="20px"></img>
						</div>&nbsp;&nbsp;在线视频站点
					</div>
					
					<div v-for="o,index in videoList" :key="o.id" class="notice" style=" cursor: pointer; height: 30px;" @click="openPath(o.url,o.id)">
				
										{{index+1}}:&nbsp;&nbsp;{{o.name}}
					</div>
				</el-card>
					
			</el-col>
			<el-col :offset="2" :span="6">
				<el-card class="box-card" shadow="hover">
					<div slot="header" class="clearfix">
						<div style="float: left;">
						<img src="https://qq-gjx-pc.oss-cn-shanghai.aliyuncs.com/icon/%E6%8A%80%E6%9C%AF%E6%9C%8D%E5%8A%A1.png" width="20px" height="20px"></img>
						</div>&nbsp;&nbsp;在线技术站点
					</div>
			<div v-for="o,index in itList" :key="o.id" class="notice" style=" cursor: pointer;  height: 30px;" @click="openPath(o.url,o.id)">
							 
								{{index+1}}:&nbsp;&nbsp;{{o.name}}
			</div>
				</el-card>
					
			</el-col>
			
			</el-row>
			<br/>
				<br/>
			<el-row>
			<el-col :offset="1" :span="6">
				<el-card class="box-card" shadow="hover">
					<div slot="header" class="clearfix">
						<div style="padding-top: 0.5%;float: left;">
						<img src="https://qq-gjx-pc.oss-cn-shanghai.aliyuncs.com/icon/%E6%9C%BA%E5%99%A8%E4%BA%BA_o.png" width="20px" height="20px"></img>
						</div>&nbsp;&nbsp;在线chatgpt
					</div>
				<div v-for="o,index in gptList" :key="o.id" class="notice" style=" cursor: pointer;  height: 30px;" @click="openPath(o.url,o.id)">
								
									{{index+1}}:&nbsp;&nbsp;{{o.name}}
				</div>
				</el-card>
					
			</el-col>
			<el-col :offset="2" :span="6">
	<el-card class="box-card" shadow="hover">
					<div slot="header" class="clearfix">
						<div style="padding-top: 0.5%;float: left;">
						<img src="https://qq-gjx-pc.oss-cn-shanghai.aliyuncs.com/icon/%E7%94%9F%E6%B4%BB.png" width="20px" height="20px"></img>
						</div>&nbsp;&nbsp;在线生活工具
					</div>
				<div v-for="o,index in liveList" :key="o.id" class="notice" style=" cursor: pointer;  height: 30px;" @click="openPath(o.url,o.id)">
								
									{{index+1}}:&nbsp;&nbsp;{{o.name}}
				</div>
				</el-card>
					
			</el-col>
			<el-col :offset="2" :span="6">
				<el-card class="box-card" shadow="hover">
					<div slot="header" class="clearfix">
						<div style="float: left;">
						<img src="https://qq-gjx-pc.oss-cn-shanghai.aliyuncs.com/icon/%E5%8F%8B%E6%83%85%E9%93%BE%E6%8E%A5.png" width="20px" height="20px"></img>
						</div>&nbsp;&nbsp;友情链接
					</div>
			<div v-for="o,index in linkList" :key="o.id" class="notice" style=" cursor: pointer;  height: 30px;" @click="openPath(o.url,o.id)">
							
								{{index+1}}:&nbsp;&nbsp;{{o.name}}
			</div>
				</el-card>
					
			</el-col>
			
			</el-row>
			
			<br/>
			<br/>
			<el-row>
			<el-col :offset="1" :span="6">
				<el-card class="box-card" shadow="hover">
					<div slot="header" class="clearfix">
						<div style="float: left;">
						<img src="https://qq-gjx-pc.oss-cn-shanghai.aliyuncs.com/icon/%E4%BA%91%E6%9C%8D%E5%8A%A1%E5%99%A8.png" width="20px" height="20px"></img>
						</div>&nbsp;&nbsp;云服务器
					</div>
				<div v-for="o,index in serverList" :key="o.id" class="notice" style=" cursor: pointer;  height: 30px;" @click="openPath(o.url,o.id)">
								
									{{index+1}}:&nbsp;&nbsp;{{o.name}}
				</div>
				</el-card>
			
					
			</el-col>
	
			
			</el-row>
			<br/>
			<br/>
		</div>
		 -->
		<el-dialog
		      title="登录注册"
		      :visible.sync="dialoglogin"
		      width="400px"
		     :close-on-click-modal='false'
		    >
			<el-card class="box-card">
				<div slot="header" class="clearfix">
					<div style="float: left;padding-top: 0.5%;"  @click="change1()">
					<img src="https://qq-gjx.oss-cn-shanghai.aliyuncs.com/pc/%E5%B0%8F%E7%A8%8B%E5%BA%8F.png" width="20px" height="20px"
					/>
					</div>&nbsp;<span @click="change1()" style=" cursor: pointer;">小程序码</span>
					
					
					<div style="float: right;padding-top: 0.5%;" @click="change2()">
						
						<img src="https://qq-gjx.oss-cn-shanghai.aliyuncs.com/pc/%E6%89%AB%E7%A0%81.png" width="20px" height="20px"
						/>
					
					</div>
					
					<span style="float: right;cursor: pointer;" @click="change2()">小程序扫码登录&nbsp;</span>
					<br>
				</div>
				<div v-if="show1" class="notice" style="text-align: center;">
					<img width="200px" height="200px" src="https://qq-gjx.oss-cn-shanghai.aliyuncs.com/pc/xcx.jpg">
					<br>
					<span>微信扫码小程序注册</span>
				</div>
				
				<div v-if="show2" class="notice" style="text-align: center;" v-loading="loading">
					<div v-if="status==0" >
					<img :src="url"  width="200px" height="200px"/>
					<br>
				
					</div>
					
					<div v-if="status==1">
					<br>
					<br>
					<span >已扫码</span>
					<br>
					<br>
					<br>
					<br>
				
					</div>
					<div v-if="status==2">
					<br>
					<br>
					<span >二维码已过期</span>
					<br>
					<br>
					<br>
					<br>
				
					</div>
					<div v-if="status==3">
					<br>
					<br>
					<span >已取消登录</span>
					<br>
					<br>
					<br>
					<br>
					
					</div>
					<el-button @click="generateQrcode()" >刷新二维码</el-button>
					
				</div>
			</el-card>
		</el-dialog>
<div style="text-align: center;margin-top: 10%;">本月访问次数:{{reqCount}}</div>
		<div style="text-align: center; ">
			copyRight@2019-{{year}}
			<img src="https://lqcpws.cn/tinyfile/1708928795702-备案图标.png" width="17" height="17"/>
			
			<a style="color: black;text-decoration: none;" href="https://beian.mps.gov.cn/#/query/webSearch" rel="noreferrer" target="_blank">赣公网安备36098102000275</a>
			&nbsp;<a href="http://beian.miit.gov.cn" style="color: black;text-decoration: none;"
			target="_blank">赣ICP备2023005166号</a>

		</div>

	</div>
</template>

<script>
	export default {
		name: 'login',
		components: {

		},
		mounted() {
			this.year=new Date().getFullYear()
			// this.$notify({
			// 	title: '签到奖励通知',
			// 	message: '1：马上就到年底了，派发奖励了<br/>' +
			// 		'2：请符合奖项的用户填写基础资料，站长会发送奖励物品或者现金<br/>' +
			// 		'3：未及时填写的视为放弃奖励，有疑问加站长qq:1311168011<br/>' +
			// 		'4：2024年的奖励会更新，前三名都有奖励(可以并列)！<br/>'+
			// 			'5：感谢本网站的赞助者！<br/>',
			// 	dangerouslyUseHTMLString: true,
			// 	duration: 30000,
			// 	type: 'warning'
			// });
			this.$api.requestCountByDay().then(res => {
				this.$api.getRequestCount().then(res2 => {
					this.reqCount = res2.data.data
				})
			
			})
			this.loadNoticeList()
			this.loadGameList()
			this.loadVideoList()
			this.loadServerList()
			this.loadItList()
			this.loadLinkList()
			this.loadLiveList()
			this.loadGptList()
			this.checkLogin()
			
			
			
		},
		destroyed() {
			clearInterval(this.timer)
		},
		data() {
			return {
				      appList: [
				        
				      ],
				      appRows: [],
				year:2023,
				dialoglogin:false,
				loading:false,
				show1:true,
				show2:false,
				status:0,
				url:'',
				title: 'login',
				fastLoginKey:"",
				time:58,
				timer:0,
				start:0,
				reqCount:0,
				noticeList: [{
						id: 1,
						content: "欢迎大家访问"
					},
					{
						id: 2,
						content: "千千万能工具箱pc正在开发中，敬请期待"
					},
				],
				imgList: [{
						id: 1,
						url: "https://bing.img.run/1920x1080.php"
					}

				],
				gameList:[],
				videoList:[],
				itList:[],
				gptList:[],
				serverList:[],
				liveList:[],
				linkList:[],
			}
		},
		methods:{
			   splitAppList() {
			      const rowSize = 4; // 每行展示的 App 数量
			      const rows = Math.ceil(this.appList.length / rowSize);
			      let currentIndex = 0;
			
			      for (let i = 0; i < rows; i++) {
			        const row = [];
			        for (let j = 0; j < rowSize; j++) {
			          if (currentIndex < this.appList.length) {
			            row.push(this.appList[currentIndex]);
			            currentIndex++;
			          }
			        }
			        this.appRows.push(row);
			      }
			    },
			openPay(){
						window.open("https://www.lqcpws.cn/tools/pay/","_blank")	
			},
			openGame(id){
			window.open("https://www.lqcpws.cn/nes/index.html?id="+id,"_blank")	
			},
			openPath(path,id,name){
				this.$api.updateClickCount({'id':id}).then(res=>{
					console.log('succ')
				})
			// 	if(path!=null&&id!=null&&name!=null){
			
			// 		localStorage.setItem("/detail",JSON.stringify({ path: path,name:name }))
			// 	this.$router.push({ path: '/detail' })
					
			
			// 	}else{
				
			// 	}
				window.open(path,"_blank")	
			},
			loadVideoList(){
				this.$api.getWebsites({menuId:3}).then(res=>{
					this.videoList=res.data.data.splice(0,8)
				
				})
			},
			loadItList(){
				this.$api.getWebsites({menuId:2}).then(res=>{
					this.itList=res.data.data.splice(0,8)
				
				})
			},
			loadGameList(){
				this.$api.getNesGamePage({page:1,limit:8}).then(res=>{
					this.gameList=res.data.data
				
				})
			},
			loadGptList(){
				this.$api.getWebsites({menuId:8}).then(res=>{
					this.gptList=res.data.data.splice(0,8)
				
				})
			},
			loadServerList(){
				this.$api.getWebsites({menuId:6}).then(res=>{
					this.serverList=res.data.data.splice(0,8)
				
				})
			},
			loadLiveList(){
				this.$api.getWebsites({menuId:10,limit:12}).then(res=>{
					// this.liveList=res.data.data.splice(0,8)
					this.appList=res.data.data.splice(0,12)
					this.splitAppList()
					console.log(this.appList)
				
				})
			},
			loadLinkList(){
				this.$api.getWebsites({menuId:9}).then(res=>{
					this.linkList=res.data.data.splice(0,8)
				
				})
			},
			openLogin(){
				this.dialoglogin=true
			},
			loadNoticeList(){
				
				this.$api.getNoticeList().then(res=>{
					this.noticeList=res.data.data
				})
			},
			checkLogin(){
				if(localStorage.getItem("token")!=undefined){
					this.$router.push('/home')
				}
			},
			waitLogin(){
				
				this.timer=setInterval(function(data){
					if(data.start==data.time){
						data.status=2;
						clearInterval(data.timer)
					}else{
						data.$api.qrCodeLogin({fastLoginKey:data.fastLoginKey}).then(res=>{
							if(res.data.data.scanCodeStatus==1){
								data.status=1
							}
							if(res.data.data.scanCodeStatus==2){
							
							localStorage.setItem("token",res.data.data.newToken)
							data.$router.push('/home')
							clearInterval(data.timer)
							}
							if(res.data.data.scanCodeStatus==3){
								data.status=3
								clearInterval(data.timer)
							}
							
						})
						
						
						data.start++
					}
					
					
				},1000,this)
				
			},
			
			generateQrcode(){
				 this.loading=true
				this.$api.generateLoginCode().then(res=>{
					
					this.status=0
					this.start=0
					this.fastLoginKey=res.data.data.fastLoginKey
					this.url=res.data.data.url
					  this.loading=false
					clearInterval(this.timer)
					this.waitLogin()
				})
			},
			change1(){
				this.show1=true
				this.show2=false
				clearInterval(this.timer)
			},
			change2(){
				this.show1=false
				this.show2=true
				this.generateQrcode()
			},
			
		}
	}
</script>

<style>
	.title-wrapper {
	  text-align: left;
	}
	
	.main-title {
	  font-size: 28px;
	  margin-top: 20px;
	  margin-bottom: 40px;
	  color: #333;
	}
	
	.divider {
	  font-size: 18px;
	  color: #666;
	  display: inline-block;
	  width: 60%;
	  margin-bottom: 30px;
	}
	
	.el-divider__text {
	  font-weight: bold;
	}
.home-container {
  text-align: center;
  padding: 10px;
}

.home-title {
  font-size: 48px;
  margin-bottom: 20px;
  color: #333;
}

.home-description {
  font-size: 24px;
  color: #666;
  margin-bottom: 30px;
}

.app-list {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
}

.app-row {
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
}

.app-card {
  width: calc(25% - 20px);
  margin: 0 10px;
  background-color: #f8f8f8;
  border-radius: 10px;
  padding: 20px;
  box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);
  transition: transform 0.3s ease;
}

.app-card:hover {
  transform: translateY(-10px);
}

.app-image-wrapper {
  text-align: center;
}

.app-image {
  width: 250px;
  height: 250px;
  border-radius: 10px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
}

.app-details {
  text-align: left;
}

.app-subtitle {
  font-size: 20px;
  margin-top: 0;
  margin-bottom: 15px;
  color: #333;
}

.app-intro {
  font-size: 18px;
  color: #666;
  margin-bottom: 15px;
}

.app-download-btn {
  font-size: 18px;
  padding: 8px 20px;
  border: none;
  border-radius: 30px;
  background-color: #00c6ff;
  color: #fff;
  cursor: pointer;
  transition: background-color 0.3s ease;
}

.app-download-btn:hover {
  background-color: #0097a7;
}
	.myLeft {
		position: absolute;
		top: 20%;
		left: 2%;
		width: 96%;
		/* height: 10%; */
		background: white;
		 opacity: 0.8;
		z-index: 1000;

	}
	.myRight {
		position: absolute;
		top: 20%;
		right: 1%;
		width:70%;
		/* height: 10%; */
		background: white;
		z-index: 1000;
		border-radius: 5px;
		 opacity: 0.8;
	}
	
	.notice{
		padding-top: 10px;
	}
</style>
